export enum SocketMessageStatus {
  SENT = 'ENVIADO',
  DELIVERED = 'ENTREGUE',
  READ = 'LIDO',
  PLAYED = 'REPRODUZIDO',
}
